import { useEffect, useState } from 'react';

const useDebounce = <T>(value: T, delay): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    let handler = setTimeout(() => {
      setDebouncedValue(value);
      handler = null;
    }, delay);

    return () => {
      if (handler) clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;

export const useDebounceDeep = <T>(value: T, delay): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    let handler = setTimeout(() => {
      setDebouncedValue(value);
      handler = null;
    }, delay);

    return () => {
      if (handler) clearTimeout(handler);
    };
  }, [JSON.stringify(value), delay]);

  return debouncedValue;
};

export const useDebounceDeepNull = <T>(value: T, delay): T => {
  const [debouncedValue, setDebouncedValue] = useState(undefined);

  useEffect(() => {
    let handler = setTimeout(() => {
      setDebouncedValue(value);
      handler = null;
    }, delay);

    return () => {
      if (handler) clearTimeout(handler);
    };
  }, [JSON.stringify(value), delay]);

  return debouncedValue;
};

export const useDebounceDeps = <T>(value: T, delay, def: T, ...deps): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(def);

  useEffect(() => {
    let handler = setTimeout(() => {
      setDebouncedValue(value);
      handler = null;
    }, delay);

    return () => {
      if (handler) clearTimeout(handler);
    };
  }, [...deps, delay]);

  return debouncedValue;
};
